export function SEAAVAXPillUnit({ value = null }) {
  return (
    <span className="pointer-events-none flex h-14 w-28 flex-none flex-row items-center justify-between space-x-2 rounded-full bg-black px-4 py-1.5 text-xs text-white md:w-40 md:px-6">
      <svg
        fill="none"
        height="32"
        viewBox="0 0 32 32"
        width="32"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect fill="white" height="32" rx="16" width="32" />
        <path
          d="M15.7031 26.8261L7.6927 22.0867C7.22325 21.8088 6.93408 21.2956 6.93408 20.7397V11.2604C6.93408 10.7045 7.22325 10.1913 7.6927 9.91342L15.7031 5.17402C16.1725 4.8961 16.7509 4.8961 17.2203 5.17402L25.2307 9.91342C25.7002 10.1913 25.9893 10.7045 25.9893 11.2604V20.7403C25.9893 21.2961 25.7002 21.8093 25.2307 22.0872L17.2203 26.8266C16.7509 27.1045 16.1725 27.1045 15.7031 26.8266V26.8261ZM9.21455 21.1861L15.7031 25.0249C16.1725 25.3028 16.7509 25.3028 17.2203 25.0249L23.7083 21.1861C24.1778 20.9082 24.467 20.395 24.467 19.8391V12.1605C24.467 11.6046 24.1778 11.0914 23.7083 10.8135L17.2203 6.97472C16.7509 6.6968 16.1725 6.6968 15.7031 6.97472L9.21455 10.814C8.7451 11.092 8.45593 11.6052 8.45593 12.161V19.8396C8.45593 20.3955 8.7451 20.9087 9.21455 21.1866V21.1861Z"
          fill="black"
        />
        <path
          d="M8.97268 10.7956L15.8079 6.75097C16.2126 6.51148 16.7109 6.51148 17.1151 6.75097L23.9503 10.795C24.355 11.0345 24.6041 11.4767 24.6041 11.9552V20.0438C24.6041 20.5223 24.355 20.965 23.9503 21.2039L17.1151 25.248C16.7103 25.4875 16.2121 25.4875 15.8079 25.248L8.97268 21.2039C8.56795 20.9644 8.31885 20.5223 8.31885 20.0438V11.9552C8.31885 11.4767 8.56795 11.034 8.97268 10.795V10.7956Z"
          fill="#FF394A"
        />
        <path
          d="M8.46539 14.0848H6.41194C6.22246 14.0848 6.06885 14.2422 6.06885 14.4364V14.9812C6.06885 15.1754 6.22246 15.3328 6.41194 15.3328H8.46539C8.65488 15.3328 8.80849 15.1754 8.80849 14.9812V14.4364C8.80849 14.2422 8.65488 14.0848 8.46539 14.0848Z"
          fill="black"
        />
        <path
          d="M8.46539 16.5809H6.41194C6.22246 16.5809 6.06885 16.7383 6.06885 16.9325V17.4773C6.06885 17.6715 6.22246 17.8289 6.41194 17.8289H8.46539C8.65488 17.8289 8.80849 17.6715 8.80849 17.4773V16.9325C8.80849 16.7383 8.65488 16.5809 8.46539 16.5809Z"
          fill="black"
        />
        <path
          d="M23.4232 11.6972L22.5711 11.5356C22.3975 11.503 22.2738 11.7035 22.377 11.8504L23.1125 12.8916C23.2162 13.0379 23.4407 12.98 23.4648 12.801L23.5814 11.9209C23.5953 11.8151 23.526 11.7162 23.4232 11.6967V11.6972Z"
          fill="black"
        />
        <path
          d="M16.5965 23.8926L17.2237 23.2799C17.3516 23.1552 17.2653 22.9346 17.0891 22.9346H15.8348C15.6582 22.9346 15.5719 23.1547 15.6998 23.2794L16.3269 23.8921C16.4024 23.9658 16.521 23.9658 16.5965 23.8921V23.8926Z"
          fill="black"
        />
        <path
          d="M16.3269 8.20055L15.6998 8.81325C15.5719 8.93799 15.6582 9.15854 15.8343 9.15854H17.0886C17.2653 9.15854 17.3516 8.93852 17.2237 8.81377L16.5966 8.20108C16.5211 8.12739 16.4024 8.12739 16.3269 8.20108V8.20055Z"
          fill="black"
        />
        <path
          d="M9.71224 20.5011L10.5479 20.7354C10.7179 20.7833 10.8581 20.5938 10.7672 20.4385L10.1201 19.3373C10.0291 19.1826 9.80007 19.2205 9.76155 19.3973L9.57305 20.2643C9.55045 20.3685 9.61157 20.4727 9.71224 20.5011Z"
          fill="black"
        />
        <path
          d="M9.72783 11.6972L10.5799 11.5356C10.7535 11.503 10.8773 11.7035 10.7741 11.8504L10.0386 12.8916C9.93482 13.0379 9.71037 12.98 9.68623 12.801L9.56963 11.9209C9.55577 11.8151 9.62511 11.7162 9.72783 11.6967V11.6972Z"
          fill="black"
        />
        <path
          d="M23.4232 20.5781L22.5711 20.7397C22.3975 20.7723 22.2738 20.5717 22.377 20.4249L23.1125 19.3837C23.2162 19.2374 23.4407 19.2953 23.4648 19.4743L23.5814 20.3543C23.5953 20.4601 23.526 20.5591 23.4232 20.5786V20.5781Z"
          fill="black"
        />
        <path
          d="M19.7237 19.53H13.5315C12.8828 19.53 12.2947 19.1631 11.9968 18.5726C11.6989 17.982 11.7467 17.2782 12.1216 16.7355L15.2218 12.2498C15.5505 11.7745 16.0862 11.4903 16.6548 11.4903C17.2234 11.4903 17.7591 11.774 18.0878 12.2498L21.1567 16.6903C21.5378 17.2419 21.586 17.9572 21.2835 18.5573C20.9805 19.1573 20.3831 19.53 19.7237 19.53ZM16.6548 13.0168C16.6034 13.0168 16.5069 13.0315 16.4375 13.132L13.3373 17.6177C13.2644 17.7235 13.2952 17.822 13.3199 17.8714C13.3445 17.9209 13.4056 18.0036 13.5315 18.0036H19.7237C19.8649 18.0036 19.9327 17.9109 19.9604 17.8562C19.9882 17.8009 20.0226 17.6909 19.9409 17.573L16.8721 13.1326C16.8027 13.032 16.7062 13.0173 16.6548 13.0173V13.0168Z"
          fill="black"
        />
      </svg>

      <div className="text-base font-bold md:text-lg">seaAVAX</div>
      {value ? <div>{(Math.round(value * 100) / 100).toFixed(2).replace(/\.?0+$/, '')}</div> : null}
    </span>
  )
}
